class MobileAppService {
    /*@ngInject*/
    constructor($log, $http, $rootScope, CommonService, HeaderNavigationService) {
        this.$log = $log;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.headerNavigationService = HeaderNavigationService;
        this.commonService = CommonService;

        $rootScope.$on('personalizeRequestSuccess', () => {
            let token = this.commonService.getPersonalizeRequestResponse().stoken;
            if (token !== "" && token !== null) {
                let memberId = this.commonService.getPersonalizeRequestResponse().memberId;
                let accountId = this.commonService.getPersonalizeRequestResponse().accountId;
                this.login(token, memberId, accountId);
            }
        });
    }

    webAppLogin(username, password) {
        let url = this.commonService.getBaseUrl() + '/j_spring_security_check';
        this.headerNavigationService.submitLogin(url, username, password, false, true);
    }

    login(token, memberId, accountId) {
        let json = '{"token": "' + token +'", "memberid": "' + memberId + '", "accountId": "' + accountId + '"}';

        this.$log.debug('mobile app login: ' + json);
        try {
            if (window.webkit !== null && window.webkit !== undefined) { // iOS
                window.webkit.messageHandlers.loginHook.postMessage(json);
            } else if (window.appInterface !== null && window.appInterface !== undefined) { // Android
                window.appInterface.login(json);
            }
        } catch (e) {
            this.$log.debug('mobile app login: ' + e);
        }
    }

    logout() {
        this.$log.debug('mobile app logout');
        try {
            if (window.webkit !== null && window.webkit !== undefined) { // iOS
                window.webkit.messageHandlers.logoutHook.postMessage("logout");
            } else if (window.appInterface !== null && window.appInterface !== undefined) { // Android
                window.appInterface.logout("logout");
            }
        } catch (e) {
            this.$log.debug('mobile app logout: ' + e);
        }
    }
}

export default MobileAppService;
